<template>
    <section>
        <div id="subHeader">
            <h1>Serviços</h1>
            <h2>O que fazemos</h2>
        </div>
        <div class="container" id="main">
            <div class="row">
                <div class="col-12 pb-3 servico" v-for="servico in servicos.data">
                    <button :data-target="`#a-${servico.id}`" class="btn w-100 p-3 collapsed" data-toggle="collapse">
                        <span>{{ servico.title }}</span>
                    </button>
                    <div :id="`a-${servico.id}`" class="collapse in p-5" v-html="servico.description"></div>
                </div>
            </div>
            <div class="d-flex mt-5">
                <div class="m-auto">
                    <pagination :data="servicos" @pagination-change-page="getResults"></pagination>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Servicos",
        metaInfo: {
            title: 'Serviços',
        },
        data() {
            return {
                servicos: {data: []}
            }
        },
        methods: {
            getResults(page = 1) {
                axios.post('/servicos', {page})
                    .then(rsp => this.servicos = rsp.data)
            }
        },
        mounted() {
            this.$parent.image = '/images/servicos.jpg';
        },
        beforeRouteEnter(to, from, next) {
            axios.post('/servicos')
                .then(rsp => next(vm => vm.servicos = rsp.data))
        }
    }
</script>

<style lang="scss" scoped>
    .servico button {
        color: #fff;
        background-color: rgba(22, 29, 30, 1);
        border-color: rgba(0, 0, 0, .6);
        text-align: left;
        text-transform: uppercase;
    }

    .servico button::after {
        content: '-';
        text-indent: 0;
        display: block;
        line-height: 48px;
        width: 48px;
        background-color: rgba(151, 169, 162, 1);
        border-color: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 4px;
        right: 20px;
        font-size: 2rem;
        color: #000;
        text-align: center;
    }

    .servico button.collapsed {
        background-color: rgba(151, 169, 162, 1);
        color: #000;
    }

    .servico button.collapsed::after {
        content: '+';
        text-indent: 0;
        display: block;
        line-height: 48px;
        width: 48px;
        background-color: rgba(22, 29, 30, 1);
        border-color: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 4px;
        right: 20px;
        font-size: 2rem;
        color: #fff;
        text-align: center;
    }

    .servico div {
        color: #fff;
        background-color: rgba(0, 0, 0, .35);
    }
</style>